module.exports = __webpack_public_path__ + "img/carteira-saida.f4e0f444.svg";